import React from 'react';
import { Loader2 } from 'lucide-react';

const SlugInputSection = ({ 
  slug, 
  setSlug, 
  isEditMode, 
  isCheckingSlug, 
  slugAvailable, 
  slugError 
}) => {
  if (isEditMode) return null;

  return (
    <div className="mb-4" style={{ paddingRight: '8px' }}>
      <label className="label">
        내 웹페이지 주소
        <span className="text-red-500 text-xs ml-1">
          * 생성 후 변경할 수 없으니 신중하게 입력해주세요
        </span>
      </label>
      <div className="flex items-center relative">
        <span className="bg-gray-100 text-gray-500 px-3 py-2.5 rounded-l-md border border-r-0 text-sm flex-shrink-0">
          latteis/
        </span>
        <div className="flex-1 relative">
          <input 
            type="text" 
            value={slug} 
            onChange={(e) => setSlug(e.target.value)} 
            className={`input rounded-l-none w-full ${
              slugError 
                ? 'input-error' 
                : slugAvailable 
                  ? 'border-green-300 focus:border-green-300' 
                  : ''
            }`} 
            placeholder="my-page" 
            style={{ 
              paddingRight: '1rem',
              boxSizing: 'border-box',
              position: 'relative',
              zIndex: 1
            }}
          />
        </div>
      </div>
      <div className="mt-1.5 min-h-[20px] text-sm">
        {isCheckingSlug && (
          <p className="text-blue-600 flex items-center gap-2">
            <Loader2 className="w-4 h-4 animate-spin" />
            주소 확인 중...
          </p>
        )}
        {slugError && <p className="form-error">{slugError}</p>}
        {slugAvailable && !isCheckingSlug && (
          <p className="text-green-600">사용 가능한 주소입니다.</p>
        )}
      </div>
    </div>
  );
};

export default SlugInputSection;
